module.exports = __webpack_public_path__ + "img/logo-footer.0b47eb6c.svg";